import { api } from "@/lib/api";

const ROOT = process.env.REACT_APP_BACKEND_URL;

export async function uploadAsset(projectId, file, kind, onProgress) {
  const { uploadStudioFile } = await import("@/lib/studio");
  return uploadStudioFile(projectId, file, onProgress);
}

export async function assetDownloadUrl(assetId) {
  const { data } = await api.get(`/creative/assets/${assetId}/download-url`);
  return data.url.startsWith("http") ? data.url : ROOT + data.url;
}

export const PAID_PLANS = ["Starter", "Growth", "Scale", "Enterprise"];
export const canUseStudio = (user) => user?.role === "admin" || PAID_PLANS.includes(user?.plan);
